<template>
  <div
    class="looking-speed"
    :class="{
      'looking-speed-0': readerCount === 0,
      'looking-speed-1': readerCount === 1,
      'looking-speed-2': readerCount === 2,
      'looking-speed-3': readerCount === 3,
      'looking-speed-4': readerCount === 4,
    }"
    @click="toggleOpen"
  >
    <v-container grid-list-md fluid pa-0>
      <v-layout row wrap>
        <v-flex md12 class="looking-speed-flex">
          <div class="looking-speed-image">
            <img :src="imageUrl" class="looking-speed-image-img" />
            &nbsp;
          </div>
          <div class="looking-speed-content">
            <div class="looking-speed-title">
              <span class="looking-speed-title-label">Reader Search Speed</span
              ><br />{{ speedLabel }}
            </div>
            <div class="looking-speed-tiny" v-html="speedMore"></div>
          </div>
          <div class="clearfix"></div>
          <!-- You're currently looking for 1 reader for your book. The more readers
          you're looking for at a time, the faster Pubby can find you interested
          readers. If you have at least 3 readers, you can Boost Your Book. When
          you use this feature, we'll show your book higher on our library pages
          until we find the 4 readers you're looking for right now. Boosted
          books typically find readers 50% faster than average. Boosting your
          book will subtract 150 snaps from your account to use. -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "BoostYourBook",
  components: {},
  props: ["assignments", "book", "isLateUnproven"],
  data: function () {
    return {
      imageUrl: null,
      isOpen: false,
      isHolding: false,
      readerCount: null,
      speedLabel: null,
      speedMore: null,
    };
  },
  watch: {
    book: function (oldValue, newValue) {
      this.loadData();
    },
  },
  created() {},
  mounted() {
    this.loadData();
  },
  methods: {
    toggleOpen() {
      this.isOpen = true;
    },
    actionClicked() {},
    loadData() {
      this.readerCount = this.assignments.length;
      this.readerCount = this.book.stats.looking_for_reviews;
      this.isHolding = this.isLateUnproven && this.book.stats.holding_unproven_reviews

      // console.log("bookstats", this.book.stats);

      if (this.readerCount > 4) {
        this.readerCount = 4;
      }

      if (this.readerCount === 0) {
        this.speedLabel = "Paused";
        if (this.isHolding) {
          this.speedMore =
          "Your requests are on hold because we haven’t been able to verify the review(s) you’ve written for others’ books.";
        } else {
        this.speedMore =
          "Ready? Use the <span class='get-reviewed-label' style='color: #fa8d1d; font-weight: 600; text-transform: uppercase; letter-spacing: 0px'>Get&nbsp;Reviewed</span> button to find a reader.";
        }
      }
      if (this.readerCount === 1) {
        this.speedLabel = "Normal";
        this.speedLabel = "Fast";
        if (this.isHolding) {
          this.speedMore = "We're prioritizing finding a reader for your book, but "
        } else {
          this.speedMore =
            "Look for <span style='font-weight:600'>multiple readers</span> at a time to find readers faster.";
        }
      }
      if (this.readerCount === 2) {
        this.speedLabel = "Fast";
        if (this.isHolding) {
          this.speedMore = "We're prioritizing finding 2 readers for your book, but "
        } else {
          this.speedMore = "Great! Look for another reader to go even faster.";
        }
      }
      if (this.readerCount === 3) {
        this.speedLabel = "Faster";
        if (this.isHolding) {
          this.speedMore = "We're prioritizing finding 3 readers for your book, but "
        } else {
          this.speedMore = "Great! Look for another reader to go even faster.";
        }
      }
      if (this.readerCount === 4) {
        this.speedLabel = "Fastest";
        this.speedMore =
          "Awesome! You're finding readers at the fastest speed.";
      }

      if (this.isHolding && this.readerCount > 0) {
        this.speedMore = this.speedMore +
          "<span style='color: #d95546;'>additonal requests are on hold until we can verify a review you’ve written for someone else's book. Please contact support with any questions or concerns!</span>";
      }

      this.imageUrl = "/images/looking-meter-" + this.readerCount + ".png";
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  font-size: 12pt;
  padding-bottom: 12px !important;
  padding-left: 0 !important;
}
.review-open .content {
  padding-top: 22px;
  //padding-bottom: 4px !important;
}

.estimate {
  padding-bottom: 12px;
  font-size: 11.5pt;
  color: #555;
}
.estimate p {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 2px !important;
}

.looking-speed {
  width: 400px;
  background: #fff;
  border: 0px solid #333;
  //box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 0 0px 8px 0px;

  padding: 0px 20px 14px 20px;
  border-radius: 8px;
  font-family: "Source Sans Pro";
  transition: all 0.2s ease-in-out;

  .looking-speed-flex {
    display: flex;
  }

  .looking-speed-image {
    width: 150px;
    max-width: 150px;
    text-align: center;
    //flex: 0;
    //height: 100px;
    //background: #ddd;

    .looking-speed-image-img {
      margin-top: 0px;
      width: 120px;
    }
  }
  .looking-speed-content {
    flex: 1;
    padding-top: 6px;
    padding-left: 8px;

    .looking-speed-title {
      font-size: 12.5pt;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #e4b600;
      text-align: center;
      border-bottom: 2px solid #f6e49b;
    }

    .looking-speed-tiny {
      padding: 4px;
      text-align: center;
      font-size: 10.5pt;
      line-height: 1.3em;
    }

    .looking-speed-title-label {
      color: #555;
      font-weight: 600;
      font-size: 10.5pt;
    }
  }

  .looking-speed-image-number {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 46px;
    left: 46px;
    background-color: #fdead0;
    padding-top: 1px;
    color: #f57c00;
    font-weight: 700;
    font-family: $font-family;
    font-size: 12pt;
    border-radius: 100px;
    text-align: center;
  }

  .looking-speed-inner {
    display: none;
    padding-top: 6px;
  }

  .looking-speed-p {
    font-size: 12pt;
    padding: 0.25em 0;
  }
}

.looking-speed-open {
  width: 85% !important;
  max-width: 540px !important;

  .looking-speed-inner {
    display: block !important;
  }
}

.is-disabled {
  background: #eee !important;
  color: #777 !important;
}

.get-reviewed-label {
  color: #f57c00 !important;
  font-weight: 700 !important;
}

.looking-speed-0 {
  .looking-speed-title {
    color: #bbb !important;
    border-bottom: 2px solid #eee !important;
  }
}
.looking-speed-1 {
  .looking-speed-title {
    color: #2196f3 !important;
    border-bottom: 2px solid #daedff !important;

    //         color: #d4b900 !important;
    // border-bottom: 2px solid #f2e79a !important;
  }
}
.looking-speed-2 {
  .looking-speed-title {
    color: #8ac203 !important;
    border-bottom: 2px solid #d4ee97 !important;
  }
}
.looking-speed-3 {
  .looking-speed-title {
    color: #fba539 !important;
    border-bottom: 2px solid #ffd49e !important;
  }
}
.looking-speed-4 {
  .looking-speed-title {
    color: #f57c00 !important;
    border-bottom: 2px solid #ffd5a9 !important;
  }
}
</style>
